<mat-card class="container">
  <mat-card-title>{{ 'filled' | transloco }}</mat-card-title>
</mat-card>
